import { Row, Col } from 'antd'
import { useDispatch, useSelector } from 'react-redux'

import { Button } from 'App/components'
import { createProcessingSelector, removeAdvertRequest, REMOVE_ADVERT } from 'store'

export type TRemoveAdvertDialogProps = {
  advertId: string
}

const processingRequest = createProcessingSelector([REMOVE_ADVERT])

export const RemoveAdvertDialog = ({ advertId }: TRemoveAdvertDialogProps) => {
  const dispatch = useDispatch()
  const processing = useSelector(processingRequest)

  const handleClick = () => {
    dispatch(removeAdvertRequest({ advertId }))
  }

  return (
    <Row gutter={[0, 28]}>
      <Col xs={24}>
        <Row justify="center">
          <span>Are you sure you want to remove this Advert?</span>
        </Row>
      </Col>
      <Col xs={24}>
        <Row justify="center">
          <Button loading={processing} onClick={handleClick}>
            Remove
          </Button>
        </Row>
      </Col>
    </Row>
  )
}
